import firebase from 'firebase';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyDkpWHfKAyKJtPFS40QQrWiWS31d7CQIRY",
  authDomain: "gdpr-21c34.firebaseapp.com",
  databaseURL: "https://gdpr-21c34.firebaseio.com",
  projectId: "gdpr-21c34",
  storageBucket: "gdpr-21c34.appspot.com",
  messagingSenderId: "330340500241"
};
firebase.initializeApp(config);


  if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const auth = firebase.auth();

export {
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js